<template>
    <div class="crm-main-cont">
        <a-tabs defaultActiveKey="0" @change="callback">
            <a-tab-pane tab="待受理" key="0">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="marRight">
                        <p>订单数：<span>{{sumWait.sumQy}}</span></p>
                        <p>申贷总额：<span>￥{{sumWait.sumSq}}</span>元</p>
                    </div>

                    <div class="search-box">
                        <a-form :form="formSearch0" layout="inline">
                            <a-form-item label="主体名称">
                                <a-input v-decorator="['companyName']"/>
                            </a-form-item>
                            <a-form-item label="信用代码">
                                <a-input v-decorator="['socialCreditUnicode']"/>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select v-decorator="['type']"
                                          placeholder="全部"
                                >
                                    <a-select-option value="">
                                        全部
                                    </a-select-option>
                                    <a-select-option :value="1">
                                        抢单
                                    </a-select-option>
                                    <a-select-option :value="0">
                                        定向
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="金融产品">
                                <a-input v-decorator="['productName']"
                                         placeholder="请选择定向后再在此处输入产品"
                                />
                            </a-form-item>
                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button type="primary" @click="handleSearch0">
                            搜索
                        </a-button>
                        <a-button @click="handleReset0">
                            重置
                        </a-button>
                        <a-button @click="exportOrder" type="primary" ghost>
                            导出
                        </a-button>
                    </div>
                    <a-table rowKey="index" bordered :dataSource="listWait" :pagination="pagination0" @change="change0"
                             :columns="columns2">
                        <template slot="productName" slot-scope="text">
                            <span v-if="text == null || text == ''">抢单</span>
                            <span v-if="text != null && text != ''">{{text}}</span>
                        </template>
                        <template slot="type" slot-scope="text">
                            <span v-if="text == '1'">抢单</span>
                            <span v-if="text == '0'">定向</span>
                        </template>
                        <template slot="warning" slot-scope="text,record">
                            <a @click="showwarning(record.socialCreditUnicode)"><span v-if="text >0"
                                                                                      style="color:orange">
                        <a-icon type="warning"/>{{text}}</span></a>
                        </template>
                        <template slot="commitAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
            <a-tab-pane tab="正在办理" key="1">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="marRight">
                        <p>订单数：<span>{{sumHandle.sumQy}}</span></p>
                        <p>申贷总额：<span>￥{{sumHandle.sumSq}}</span>元</p>
                    </div>
                    <div class="search-box">
                        <a-form :form="formSearch1" layout="inline">
                            <a-form-item label="主体名称">
                                <a-input v-decorator="['companyName']"/>
                            </a-form-item>
                            <a-form-item label="信用代码">
                                <a-input v-decorator="['socialCreditUnicode']"/>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select v-decorator="['type']"
                                          placeholder="全部"
                                >
                                    <a-select-option value="">
                                        全部
                                    </a-select-option>
                                    <a-select-option :value="1">
                                        抢单
                                    </a-select-option>
                                    <a-select-option :value="0">
                                        定向
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="金融产品">
                                <a-input v-decorator="['productName']"
                                         placeholder="请选择定向后再在此处输入产品"
                                />
                            </a-form-item>
                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button type="primary" @click="handleSearch1">
                            搜索
                        </a-button>
                        <a-button @click="handleReset1">
                            重置
                        </a-button>
                        <a-button @click="exportOrder" type="primary" ghost>
                            导出
                        </a-button>
                    </div>
                    <a-table rowKey="id" bordered :dataSource="listHandle" :pagination="pagination" @change="change"
                             :columns="columns2">
                        <template slot="productName" slot-scope="text">
                            <span v-if="text == null || text == ''">抢单</span>
                            <span v-if="text != null && text != ''">{{text}}</span>
                        </template>
                        <template slot="type" slot-scope="text">
                            <span v-if="text == '1'">抢单</span>
                            <span v-if="text == '0'">定向</span>
                        </template>
                        <template slot="warning" slot-scope="text,record">
                            <a @click="showwarning(record.socialCreditUnicode)"><span v-if="text >0"
                                                                                      style="color:orange">
                        <a-icon type="warning"/>{{text}}</span></a>
                        </template>
                        <template slot="commitAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
            <a-tab-pane tab="已授信" key="3">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="marRight">
                        <p>订单数：<span>{{sumCompliance.sumQy}}</span></p>
                        <p>申贷总额：<span>￥{{sumCompliance.sumSq}}</span>元</p>
                        <p>授信总额：<span>￥{{sumCompliance.sumFd}}</span>元</p>
                    </div>
                    <div class="search-box">
                        <a-form :form="formSearch3" layout="inline">
                            <a-form-item label="主体名称">
                                <a-input v-decorator="['companyName']"/>
                            </a-form-item>
                            <a-form-item label="信用代码">
                                <a-input v-decorator="['socialCreditUnicode']"/>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select v-decorator="['type']"
                                          placeholder="全部"
                                >
                                    <a-select-option value="">
                                        全部
                                    </a-select-option>
                                    <a-select-option :value="1">
                                        抢单
                                    </a-select-option>
                                    <a-select-option :value="0">
                                        定向
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="金融产品">
                                <a-input v-decorator="['productName']"
                                         placeholder="请选择定向后再在此处输入产品"
                                />
                            </a-form-item>
                            <a-form-item label="受理银行">
                                <a-input v-decorator="['serviceBank']"/>
                            </a-form-item>
                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button type="primary" @click="handleSearch3">
                            搜索
                        </a-button>
                        <a-button @click="handleReset3">
                            重置
                        </a-button>
                        <a-button @click="exportOrder" type="primary" ghost>
                            导出
                        </a-button>
                    </div>
                    <a-table rowKey="id" bordered :dataSource="listCompliance" :pagination="pagination2"
                             @change="change2" :columns="columns">
                        <template slot="productName" slot-scope="text">
                            <span v-if="text == null || text == ''">抢单</span>
                            <span v-if="text != null && text != ''">{{text}}</span>
                        </template>
                        <template slot="commitAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="loanAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="warning" slot-scope="text,record">
                            <a @click="showwarning(record.socialCreditUnicode)"><span v-if="text >0"
                                                                                      style="color:orange">
                        <a-icon type="warning"/>{{text}}</span></a>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
            <a-tab-pane tab="已结清" key="4">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="marRight">
                        <p>订单数：<span>{{sumSettle.sumQy}}</span></p>
                        <p>申贷总额：<span>￥{{sumSettle.sumSq}}</span>元</p>
                        <p>授信总额：<span>￥{{sumSettle.sumFd}}</span>元</p>
                    </div>
                    <div class="search-box">
                        <a-form :form="formSearch4" layout="inline">
                            <a-form-item label="主体名称">
                                <a-input v-decorator="['companyName']"/>
                            </a-form-item>
                            <a-form-item label="信用代码">
                                <a-input v-decorator="['socialCreditUnicode']"/>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select v-decorator="['type']"
                                          placeholder="全部"
                                >
                                    <a-select-option value="">
                                        全部
                                    </a-select-option>
                                    <a-select-option :value="1">
                                        抢单
                                    </a-select-option>
                                    <a-select-option :value="0">
                                        定向
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="金融产品">
                                <a-input v-decorator="['productName']"
                                         placeholder="请选择定向后再在此处输入产品"
                                />
                            </a-form-item>
                            <a-form-item label="受理银行">
                                <a-input v-decorator="['serviceBank']"/>
                            </a-form-item>
                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button type="primary" @click="handleSearch4">
                            搜索
                        </a-button>
                        <a-button @click="handleReset4">
                            重置
                        </a-button>
                        <a-button @click="exportOrder" type="primary" ghost>
                            导出
                        </a-button>
                    </div>
                    <a-table rowKey="id" bordered :dataSource="listSettle" :pagination="pagination3" @change="change3"
                             :columns="columns">
                        <template slot="productName" slot-scope="text">
                            <span v-if="text == null || text == ''">抢单</span>
                            <span v-if="text != null && text != ''">{{text}}</span>
                        </template>
                        <template slot="commitAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="loanAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="warning" slot-scope="text">
                            <span v-if="text >0" style="color:orange"><a-icon type="warning"/>{{text}}</span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
            <a-tab-pane tab="拒贷" key="2">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="marRight">
                        <p>订单数：<span>{{sumRefuse.sumQy}}</span></p>
                        <p>申贷总额：<span>￥{{sumRefuse.sumSq}}</span>元</p>
                    </div>
                    <div class="search-box">
                        <a-form :form="formSearch2" layout="inline">
                            <a-form-item label="主体名称">
                                <a-input v-decorator="['companyName']"/>
                            </a-form-item>
                            <a-form-item label="信用代码">
                                <a-input v-decorator="['socialCreditUnicode']"/>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select v-decorator="['type']"
                                          placeholder="全部"
                                >
                                    <a-select-option value="">
                                        全部
                                    </a-select-option>
                                    <a-select-option :value="1">
                                        抢单
                                    </a-select-option>
                                    <a-select-option :value="0">
                                        定向
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="金融产品">
                                <a-input v-decorator="['productName']"
                                         placeholder="请选择定向后再在此处输入产品"
                                />
                            </a-form-item>
                            <a-form-item label="受理银行">
                                <a-input v-decorator="['serviceBank']"/>
                            </a-form-item>
                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button type="primary" @click="handleSearch2">
                            搜索
                        </a-button>
                        <a-button @click="handleReset2">
                            重置
                        </a-button>
                        <a-button @click="exportOrder" type="primary" ghost>
                            导出
                        </a-button>
                    </div>
                    <a-table rowKey="id" bordered :dataSource="listRefuse" :pagination="pagination1" @change="change1"
                             :columns="columns3">
                        <template slot="productName" slot-scope="text">
                            <span v-if="text == null || text == ''">抢单</span>
                            <span v-if="text != null && text != ''">{{text}}</span>
                        </template>
                        <template slot="commitAmout" slot-scope="text">
                            <span v-if="text != null && text != ''">{{changeNum(text)}}</span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
        </a-tabs>
        <a-drawer
            :title="showItem.financingRequirementsCode==null?'查看详情':'查看详情,省统一需求编码：'+showItem.financingRequirementsCode"
                :width="650"
                @close="onClose"
                :visible="hide"
        >
            <a-descriptions title="主体信息" :column="2" bordered>
                <a-descriptions-item label="主体名称">
                    {{ showItem.companyName }}
                </a-descriptions-item>
                <a-descriptions-item label="统一社会信用代码">
                    {{ showItem.socialCreditUnicode }}
                </a-descriptions-item>
                <a-descriptions-item label="法定代表人" v-if="showItem.zttype===2">
                    {{ showItem.frdb }}
                </a-descriptions-item>
<!--                <a-descriptions-item label="所属行业" v-if="showItem.type===1">
                    {{ showItem.industry }}
                </a-descriptions-item>-->
                <a-descriptions-item label="主体所在省市区" v-if="showItem.type===1">
                    {{ showItem.area }}
                </a-descriptions-item>
                <a-descriptions-item :label="showItem.zttype===2?'经营地址':'联系地址'">
                    {{ showItem.address }}
                </a-descriptions-item>
            </a-descriptions>
            <a-descriptions title="融资信息" :column="2" bordered>
                <a-descriptions-item label="申请产品">
                    {{ showItem.productName==null?'-':showItem.productName }}
                </a-descriptions-item>
                <a-descriptions-item label="申贷金额">
                    {{
                    String(showItem.commitAmout).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                    )
                    }}元
                </a-descriptions-item>
                <a-descriptions-item label="经办人">
                    {{ showItem.contact }}
                </a-descriptions-item>
                <a-descriptions-item label="经办人身份证号码" v-if="showItem.type===0">
                    {{ showItem.contactIdcard }}
                </a-descriptions-item>
                <a-descriptions-item :label="showItem.type===1?'手机号码':'经办人手机号码'">
                    {{ showItem.contactMobile }}
                </a-descriptions-item>
                <a-descriptions-item label="是否首贷户">
                  {{ showItem.isFirstUser===0?'是':'否' }}
                </a-descriptions-item>
                <a-descriptions-item label="申请日期">
                    {{ showItem.createTime==null?'-':showItem.createTime }}
                </a-descriptions-item>
            </a-descriptions>
            <a-descriptions style="margin-top: 20px" title="融资期望信息" :column="2" bordered>
                <a-descriptions-item label="期望金额">
                    {{
                    String(showItem.commitAmout).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                    )
                    }}元
                </a-descriptions-item>
                <a-descriptions-item label="期望的年利率">
                    {{ showItem.interestRate==null?'-':showItem.interestRate+'%' }}
                </a-descriptions-item>
                <a-descriptions-item label="期望的融资期限">
                    {{ showItem.deadline==null?'-':showItem.deadline+'个月' }}
                </a-descriptions-item>
                <a-descriptions-item label="期望贷款到账时间">
                    {{ showItem.loanArrival==null?'-':showItem.loanArrival+'天' }}
                </a-descriptions-item>
              <a-descriptions-item label="贷款用途">
                {{showItem.yt }}
              </a-descriptions-item>
            </a-descriptions>
            <a-descriptions style="margin-top: 20px" title="企业信息" :column="2" bordered>
                <a-descriptions-item label="上年度纳税金额">
                    {{ showItem.taxAmountOfLastYear==null?'-':showItem.taxAmountOfLastYear }}
                </a-descriptions-item>
                <a-descriptions-item label="企业盈亏状况">
                    {{ showItem.profitOrLossStatus==null?'-':showItem.profitOrLossStatus }}
                </a-descriptions-item>
                <a-descriptions-item label="上年度开票营业收入">
                    {{ showItem.businessIncome==null?'-':showItem.businessIncome }}
                </a-descriptions-item>
                <a-descriptions-item label="纳税等级">
                    {{ showItem.taxGrade==null?'-':showItem.taxGrade }}
                </a-descriptions-item>
                <a-descriptions-item label="是否有抵押物">
                    {{ showItem.isCollateral==null?'-':showItem.isCollateral }}
                </a-descriptions-item>
                <a-descriptions-item label="开户行">
                    {{ showItem.bankOfDeposit==null?'-':showItem.bankOfDeposit }}
                </a-descriptions-item>
                <a-descriptions-item label="当前贷款余额">
                    {{ showItem.currentLoanBalance==null?'-':String(showItem.currentLoanBalance).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                    )
                    +'元'}}
                </a-descriptions-item>
                <a-descriptions-item label="贷款到账时间">
                    {{ showItem.loanArrival==null?'-':showItem.loanArrival+'天' }}
                </a-descriptions-item>
                <a-descriptions-item label="之前贷款机构">
                    {{ showItem.previousLendingInstitutions==''||showItem.previousLendingInstitutions==undefined?'-':showItem.previousLendingInstitutions }}
                </a-descriptions-item>
            </a-descriptions>
            <a-descriptions title="授信信息" :column="2" bordered>
                <a-descriptions-item label="授信金额">
              <span v-if="showItem.loanAmout != null">{{
                  String(showItem.loanAmout).replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ","
                  )
                }}元</span>
                    <span v-if="showItem.loanAmout == null">-</span>
                </a-descriptions-item>
                <a-descriptions-item label="授信利率">
              <span v-if="showItem.interestRate != null">{{Number(showItem.interestRate).toFixed(4)}}%</span>
                    <span v-if="showItem.interestRate == null">-</span>
                </a-descriptions-item>
                <a-descriptions-item label="授信日期">
              <span v-if="showItem.loanTime != null">{{
                  showItem.loanTime
                }}</span>
                    <span v-if="showItem.loanTime == null">-</span>
                </a-descriptions-item>
                <a-descriptions-item label="授信期限">
              <span v-if="showItem.deadline != null">{{
                  showItem.deadline
                }}个月</span>
                    <span v-if="showItem.deadline == null">-</span>
                </a-descriptions-item>
            </a-descriptions>
            <a-descriptions title="受理机构信息" :column="2" bordered v-if="showItem.yxdwUserId!=null">
                <a-descriptions-item label="受理人">
                    {{account.name}}
                </a-descriptions-item>
                <a-descriptions-item label="受理人手机">
                    {{account.mobile}}
                </a-descriptions-item>
                <a-descriptions-item label="受理机构">
                    {{account.department}}{{account.nickName}}
                </a-descriptions-item>
          <a-descriptions-item label="受理时间">
            {{showItem.acceptTime}}
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions title="拒贷信息" :column="2" bordered v-if="shstate==2">
          <a-descriptions-item label="拒贷理由">
            {{showItem.jdResult}}
          </a-descriptions-item>
          <a-descriptions-item label="拒贷时间">
            {{formatDate(showItem.jdrq)}}
          </a-descriptions-item>
        </a-descriptions>
      </a-drawer>
      <warning ref="warning" />
    </div>
</template>

<script>
import {finenceList,getRefusalOfLoanByFinanceId,exportOrderByStatus} from "@/api/operate/monitor";
import {getAccount} from "@/api/yhgl/account";
import warning from '@/pages/operate/warning.vue'
import {getTypes} from '@/api/finance/finance'

const columns = [
    {
        title: '主体名称',
        dataIndex: 'companyName',
        width: 130,
    }, {
        title: '统一社会信用代码',
        dataIndex: 'socialCreditUnicode',
        key: "socialCreditUnicode",
        width: 100,
    }, {
        title: '申请日期',
        dataIndex: 'createTime',
        key: "commitTime",
        width: 110,
    }, {
        title: '金融产品',
        dataIndex: 'productName',
        key: "productName",
        scopedSlots: {customRender: 'productName'},
        width: 100,
    },
    {
        title: '申贷金额(元)',
        dataIndex: 'commitAmout',
        key: "commitAmout",
        scopedSlots: {customRender: 'commitAmout'},
        width: 110,
    }, {
        title: '受理日期',
        dataIndex: 'acceptTime',
        key: "acceptTime",
        width: 110,
    }, {
        title: '受理银行',
        dataIndex: 'logindept',
        key: "logindept",
        scopedSlots: {customRender: 'logindept'},
        width: 150,
    }, {
        title: '授信日期',
        key: "loanTime",
        dataIndex: 'loanTime',
        width: 110,
    }, {
        title: '授信金额(元)',
        key: "loanAmout",
        dataIndex: 'loanAmout',
        scopedSlots: {customRender: 'loanAmout'},
        width: 110,
    }, {
        title: '贷款期限(月)',
        key: "deadline",
        dataIndex: 'deadline',
        width: 110,
    }, {
        title: '贷款利率(%)',
        key: "interestRate",
        dataIndex: 'interestRate',
        width: 110,
    }, {
        title: '预警信息',
        key: "warning",
        dataIndex: 'warning',
        scopedSlots: {customRender: 'warning'},
        width: 100
    }, {
        title: "操作",
        dataIndex: "operation",
        scopedSlots: {customRender: "operation"},
    }
];

const columns3 = [
    {
        title: '主体名称',
        dataIndex: 'companyName',
    }, {
        title: '统一社会信用代码',
        dataIndex: 'socialCreditUnicode',
        key: "socialCreditUnicode",
    }, {
        title: '申请日期',
        dataIndex: 'createTime',
        key: "commitTime",
    }, {
        title: '金融产品',
        dataIndex: 'productName',
        key: "productName",
        scopedSlots: {customRender: 'productName'},
    },
    {
        title: '申贷金额(元)',
        dataIndex: 'commitAmout',
        key: "commitAmout",
        scopedSlots: {customRender: 'commitAmout'},
    }, {
        title: '受理日期',
        dataIndex: 'acceptTime',
        key: "acceptTime",
    }, {
        title: '受理银行',
        dataIndex: 'logindept',
        key: "logindept",
        scopedSlots: {customRender: 'logindept'},
    }, {
        title: '贷款期限(月)',
        key: "deadline",
        dataIndex: 'deadline',
    }, {
        title: "操作",
        dataIndex: "operation",
        scopedSlots: {customRender: "operation"},
    }
];

const columns2 = [
    {
        title: '主体名称',
        dataIndex: 'companyName',
    }, {
        title: '统一社会信用代码',
        dataIndex: 'socialCreditUnicode',
        key: "socialCreditUnicode",
    }, {
        title: '申请日期',
        dataIndex: 'createTime',
        key: "commitTime",
    }, {
        title: '金融产品',
        dataIndex: 'productName',
        key: "productName",
        scopedSlots: {customRender: 'productName'},
    },
    {
        title: '申贷金额(元)',
        dataIndex: 'commitAmout',
        key: "commitAmout",
        scopedSlots: {customRender: 'commitAmout'},
    }, {
        title: '预警信息',
        key: "warning",
        dataIndex: 'warning',
        scopedSlots: {customRender: 'warning'}
    }, {
        title: "类型",
        dataIndex: "type",
        scopedSlots: {customRender: "type"},
    }, {
        title: "操作",
        dataIndex: "operation",
        scopedSlots: {customRender: "operation"},
    }
];

export default {
    components: {
        warning
    },
    data() {
        return {
            spinning: false,
            columns,
            columns2,
            columns3,
            showItem: "",
            account: {},
            hide: false,
            formSearch0: this.$form.createForm(this),
            formSearch1: this.$form.createForm(this),
            formSearch2: this.$form.createForm(this),
            formSearch3: this.$form.createForm(this),
            formSearch4: this.$form.createForm(this),
            /*form: this.$form.createForm(this),
            form2: this.$form.createForm(this),
            hide: false,
            visible: false,
            visible2: false,*/
            confirmLoading: false,
            listWait: [],
            industryList: [],
            listHandle: [],
            listCompliance: [],
            listSettle: [],
            listRefuse: [],
            search0: {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            },
            search1: {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            },
            search2: {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            },
            search3: {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            },
            search4: {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            },
            sumWait: {
                sumQy: 0,
                sumSq: 0,
                sumFd: 0
            },
            sumRefuse: {
                sumQy: 0,
                sumSq: 0,
                sumFd: 0
            },
            sumHandle: {
                sumQy: 0,
                sumSq: 0,
                sumFd: 0
            },
            sumCompliance: {
                sumQy: 0,
                sumSq: 0,
                sumFd: 0
            },
            sumSettle: {
                sumQy: 0,
                sumSq: 0,
                sumFd: 0
            },
            shstate: "0",
            pagination0: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            pagination1: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            pagination2: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            pagination3: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        };
    },
    //列表显示
    beforeRouteEnter(to, from, next) {
        finenceList(1, 0)
            .then(res => {
                next(vm => {
                    if (res.data.success === "TRUE") {
                        vm.listWait = res.data.data.page.list;
                        vm.sumWait = {
                            sumQy: res.data.data.sum.sumQy,
                            sumSq: vm.changeNum(res.data.data.sum.sumSq),
                            sumFd: vm.changeNum(res.data.data.sum.sumFd),
                        };
                        vm.pagination0 = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        vm.getIndustry();
                    }
                });
            })
            .catch(err => {
                next(vm => {
                    vm.$message.error("服务器出错！请稍后再试!");
                    vm.$Progress.fail();
                });
            });
    },
    methods: {
        handleSearch0() {
            let values = this.formSearch0.getFieldsValue();
            Object.assign(this.search0, {
                companyName: values.companyName || "",
                socialCreditUnicode: values.socialCreditUnicode || "",
                type: values.type,
                productName: values.productName || "",
                serviceBank: values.serviceBank || "",
                pageNum: 1
            });
            this.initList();
        },
          //审核时间转换
          formatDate(dates) {
            dates = new Date(dates);
            let date = {
              year: dates.getFullYear(),
              month:
                  dates.getMonth() + 1 < 10
                      ? "0" + (dates.getMonth() + 1)
                      : dates.getMonth() + 1,
              day:
                  dates.getDate() < 10
                      ? "0" + dates.getDate()
                      : dates.getDate(),
              hour:
                  dates.getHours() < 10
                      ? "0" + dates.getHours()
                      : dates.getHours(),
              minute:
                  dates.getMinutes() < 10
                      ? "0" + dates.getMinutes()
                      : dates.getMinutes(),
              second:
                  dates.getSeconds() < 10
                      ? "0" + dates.getSeconds()
                      : dates.getSeconds()
            };
            return (
                date.year +
                "-" +
                date.month +
                "-" +
                date.day +
                " " +
                date.hour +
                ":" +
                date.minute +
                ":" +
                date.second
            );
          },
          handleReset0() {
            this.formSearch0.resetFields();
            Object.assign(this.search0, {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            });
            this.initList();
        },
        handleSearch1() {
            let values = this.formSearch1.getFieldsValue();
            console.log(values.type);
            Object.assign(this.search1, {
                companyName: values.companyName || "",
                socialCreditUnicode: values.socialCreditUnicode || "",
                type: values.type,
                productName: values.productName || "",
                serviceBank: values.serviceBank || "",
                pageNum: 1
            });
            this.initList();
        },
        handleReset1() {
            this.formSearch1.resetFields();
            Object.assign(this.search1, {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            });
            this.initList();
        },
        handleSearch2() {
            let values = this.formSearch2.getFieldsValue();
            Object.assign(this.search2, {
                companyName: values.companyName || "",
                socialCreditUnicode: values.socialCreditUnicode || "",
                type: values.type,
                productName: values.productName || "",
                serviceBank: values.serviceBank || "",
                pageNum: 1
            });
            this.initList();
        },
        handleReset2() {
            this.formSearch2.resetFields();
            Object.assign(this.search2, {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            });
            this.initList();
        },
        getIndustry() {
            getTypes("003008")
                .then(res => {
                    if (res.data.success == "TRUE") {
                        this.industryList = res.data.data.list;
                    }
                }).catch(() => {
                this.$message.error("服务器出错！请稍后再试!");
            });
        },
        handleSearch3() {
            let values = this.formSearch3.getFieldsValue();
            Object.assign(this.search3, {
                companyName: values.companyName || "",
                socialCreditUnicode: values.socialCreditUnicode || "",
                type: values.type,
                productName: values.productName || "",
                serviceBank: values.serviceBank || "",
                pageNum: 1
            });
            this.initList();
        },
        handleReset3() {
            this.formSearch3.resetFields();
            Object.assign(this.search3, {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            });
            this.initList();
        },
        handleSearch4() {
            let values = this.formSearch4.getFieldsValue();
            Object.assign(this.search4, {
                companyName: values.companyName || "",
                socialCreditUnicode: values.socialCreditUnicode || "",
                type: values.type,
                productName: values.productName || "",
                serviceBank: values.serviceBank || "",
                pageNum: 1
            });
            this.initList();
        },
        handleReset4() {
            this.formSearch4.resetFields();
            Object.assign(this.search4, {
                companyName: "",
                socialCreditUnicode: "",
                type: "",
                productName: "",
                serviceBank: "",
                pageNum: 1
            });
            this.initList();
        },
        exportOrder(){
            let statusName = this.shstate === "0"?"待受理":
                this.shstate === "1"?"正在办理":
                    this.shstate === "2"?"拒贷":
                        this.shstate === "3"?"已授信":
                            this.shstate ==="4"?"已结清":"";
            let data = new FormData();
            data.append("status",this.shstate)
            exportOrderByStatus(data).then(res=>{
                let blob=res.data;
                let reader=new FileReader();
                reader.readAsDataURL(blob);
                reader.onload=(e)=>{
                    let a=document.createElement('a');
                    a.download=`融资动态(${statusName}).xls`;
                    a.href=e.target.result;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            }).catch(()=>{
                this.$message.error("服务器异常，请稍后再试！")
            })
        },
        changeNum(num) {
            var a = num + "";
            var d = a;
            var c = d.split('.').reverse();
            if (c.length == 2) {
                var x = this.changeNum(c[1]);
                return x + "." + c[0];
            }
            //1.使用split把字符串分割成数组;
            //2.使用reverse将数组进行翻转;
            var b = a.split('').reverse();

            //3.遍历数组，并在第(i+1)%4，第四个前用splice(i,0,',')插入",";
            for (var i = 0; i < b.length; i++) {
                if ((i + 1) % 4 == 0) {
                    b.splice(i, 0, ',');
                }
            }
            b.reverse(); // 1 , 2 5 8 , 7 4 6

            //4.使用reverse再次翻转数组，遍历数组，空字符追加每个值;
            var str = '';
            for (var i = 0; i < b.length; i++) {
                str += b[i]
            }
            return str;
        },
        //切换tab 赋值状态
        callback(key) {
            console.log(key);
            this.shstate = key;
            let values0 = this.formSearch0.getFieldsValue();
            Object.assign(this.search0, {
                companyName: values0.companyName || "",
                socialCreditUnicode: values0.socialCreditUnicode || "",
                type: values0.type,
                productName: values0.productName || "",
                serviceBank: values0.serviceBank || "",
                pageNum: 1
            });
            let values1 = this.formSearch1.getFieldsValue();
            Object.assign(this.search1, {
                companyName: values1.companyName || "",
                socialCreditUnicode: values1.socialCreditUnicode || "",
                type: values1.type,
                productName: values1.productName || "",
                serviceBank: values1.serviceBank || "",
                pageNum: 1
            });
            let values2 = this.formSearch2.getFieldsValue();
            Object.assign(this.search2, {
                companyName: values2.companyName || "",
                socialCreditUnicode: values2.socialCreditUnicode || "",
                type: values2.type,
                productName: values2.productName || "",
                serviceBank: values2.serviceBank || "",
                pageNum: 1
            });
            let values3 = this.formSearch3.getFieldsValue();
            Object.assign(this.search3, {
                companyName: values3.companyName || "",
                socialCreditUnicode: values3.socialCreditUnicode || "",
                type: values3.type,
                productName: values3.productName || "",
                serviceBank: values3.serviceBank || "",
                pageNum: 1
            });
            let values4 = this.formSearch4.getFieldsValue();
            Object.assign(this.search4, {
                companyName: values4.companyName || "",
                socialCreditUnicode: values4.socialCreditUnicode || "",
                type: values4.type,
                productName: values4.productName || "",
                serviceBank: values4.serviceBank || "",
                pageNum: 1
            });
            this.initList();
        },
        //分页切换
      change0(page) {
        this.pagination0.current = page.current;
        this.search0.pageNum = page.current;
        this.initList();
        this.spinning = false;
      },
        change(page) {
            this.pagination.current = page.current;
            this.search1.pageNum = page.current;
            this.initList();
            this.spinning = false;
        },
        change1(page) {
            this.pagination1.current = page.current;
            this.search2.pageNum = page.current;
            this.initList();
            this.spinning = false;
        },
        change2(page) {
            this.pagination2.current = page.current;
             this.search3.pageNum = page.current;
            this.initList();

            this.spinning = false;
        },
        change3(page) {
            this.pagination3.current = page.current;
          this.search4.pageNum = page.current;
            this.initList();
            this.spinning = false;
        },
        showwarning(uscc) {
            this.$refs.warning.showmodal(uscc);
        },
        initList() {
            this.spinning = true;
            if (this.shstate === '0') {
                finenceList(this.search0, this.shstate).then(res => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.listWait = res.data.data.page.list;
                        this.sumWait = {
                            sumQy: res.data.data.sum.sumQy,
                            sumSq: this.changeNum(res.data.data.sum.sumSq),
                            sumFd: this.changeNum(res.data.data.sum.sumFd),
                        };
                        this.pagination0 = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        this.search0 = {
                            pageNum: res.data.data.page.pageNum
                        };
                    }
                });
            } else if (this.shstate === '1') {
                finenceList(this.search1, this.shstate).then(res => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.listHandle = res.data.data.page.list;
                        this.sumHandle = {
                            sumQy: res.data.data.sum.sumQy,
                            sumSq: this.changeNum(res.data.data.sum.sumSq),
                            sumFd: this.changeNum(res.data.data.sum.sumFd),
                        };
                        this.pagination = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        this.search1 = {
                            pageNum: res.data.data.page.pageNum
                        };
                    }
                });
            } else if (this.shstate === '2') {
                finenceList(this.search2, this.shstate).then(res => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.listRefuse = res.data.data.page.list;
                        this.sumRefuse = {
                            sumQy: res.data.data.sum.sumQy,
                            sumSq: this.changeNum(res.data.data.sum.sumSq),
                            sumFd: this.changeNum(res.data.data.sum.sumFd),
                        };
                        this.pagination1 = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        this.search2 = {
                            pageNum: res.data.data.page.pageNum
                        };
                    }
                });
            } else if (this.shstate === '3') {
                finenceList(this.search3, this.shstate).then(res => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.listCompliance = res.data.data.page.list;
                        this.sumCompliance = {
                            sumQy: res.data.data.sum.sumQy,
                            sumSq: this.changeNum(res.data.data.sum.sumSq),
                            sumFd: this.changeNum(res.data.data.sum.sumFd),
                        };
                        this.pagination2 = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        this.search3 = {
                            pageNum: res.data.data.page.pageNum
                        };
                    }
                });
            } else if (this.shstate === '4') {
                finenceList(this.search4, this.shstate).then(res => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.listSettle = res.data.data.page.list;
                        this.sumSettle = {
                            sumQy: res.data.data.sum.sumQy,
                            sumSq: this.changeNum(res.data.data.sum.sumSq),
                            sumFd: this.changeNum(res.data.data.sum.sumFd),
                        };
                        this.pagination3 = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        this.search4 = {
                            pageNum: res.data.data.page.pageNum
                        };
                    }
                });
            }
        },
      async show(data) {
            this.hide = true;
            this.account ={};
            this.showItem = data;
            /*this.showItem.industry = data.industry == null ? "" : this.industryList.find(item => item.param == data.industry).desc;*/
            if (data.yxdwUserId != null) {
                getAccount(data.yxdwUserId).then(res => {
                    if (res.data.success === "TRUE") {
                        this.account = res.data.data.account;
                    }
                })
            }
        if (this.shstate == 2) {

          await getRefusalOfLoanByFinanceId(data.id).then(res => {
            if (res.data.success == "TRUE") {
              this.showItem.jdResult = res.data.data.data.jdresult;
              this.showItem.jdrq = res.data.data.data.jdrq;
            }
          }).catch(() => {
            //this.$message.error("服务器异常，请稍后再试")
          })
        }
        },
        onClose() {
            this.hide = false;
        }
        /*showModal() {
            this.visible = true
        },
        handleOk(e) {
            this.confirmLoading = true;
            setTimeout(() => {
                this.visible = false;
                this.confirmLoading = false;
            }, 2000);
        },
        handleCancel(e) {
            this.visible = false
        },*/
    },
}
</script>
<style scoped lang="less">

    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 169px;
        }
    }

    .btns-group button {
        margin-right: 10px;
        margin-top: 24px;
        margin-bottom: 20px;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 16px;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab-active {
        font-size: 16px;
    }

    /deep/ .btns-group {
        text-align: center;
    }

    /deep/ .ant-descriptions-title {
        margin-bottom: 10px !important;
    }

    .ant-descriptions-bordered {
        margin-bottom: 20px;
    }

    .marRight {
        margin-bottom: 30px;

        p {
            display: inline-block;
            width: 300px;
            font-size: 16px;

            span {
                font-family: 'DIN_Condensed_Bold';
                color: #1492ff;
                font-size: 18px;
                margin-right: 5px;
            }
        }
    }
</style>
